import { render, staticRenderFns } from "./SiestaInstruction.vue?vue&type=template&id=04254de2&scoped=true&"
import script from "./SiestaInstruction.vue?vue&type=script&lang=js&"
export * from "./SiestaInstruction.vue?vue&type=script&lang=js&"
import style0 from "./SiestaInstruction.vue?vue&type=style&index=0&id=04254de2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04254de2",
  null
  
)

export default component.exports